import React from "react";
import Arsenal from "../assets/Arsenal.png";
import CText from "../Components/CText";
import { Col, Row } from "reactstrap";
import HTML from "../assets/html.jpg";
import CSS from "../assets/css.jpg";
import JS from "../assets/js.png";
import REACT from "../assets/React.jpg";
import WEB3 from "../assets/web3.png";
import TS from "../assets/ts.png";
import GITHUB from "../assets/github.jpg";
import BOOTSTRAP from "../assets/bootstrap.png";

function Skills() {
  return (
    <div className="skillsSection">
      <CText
        className="headingText"
        fontSize="2.5rem"
        text={
          <p className="d-flex align-items-center justify-content-center">
            My Coding Arsenal
            {/* <img className="m-2" width="40px" src={Arsenal} />{" "} */}
          </p>
        }
      />
      <CText
        className="subHeading"
        fontSize="1.2rem"
        text={
          <p className="d-flex align-items-center justify-content-center">
            Welcome to my Coding Arsenal, witness the Art of Digital Creation.
            My Coding Arsenal Holds the Key to Limitless Possibilities.
          </p>
        }
      />

      <Row className="mb-2" lg="4"  xs="2">
        <Col className="d-flex justify-content-center mb-5">
          <img width="120px" src={HTML} />
        </Col>
        <Col className="d-flex justify-content-center mb-5">
          <img width="120px" src={CSS} />
        </Col>
        <Col className="d-flex justify-content-center mb-5">
          <img width="120px" src={BOOTSTRAP} />
        </Col>
        <Col className="d-flex justify-content-center mb-5">
          <img width="120px" src={JS} />
        </Col>
        <Col className="d-flex justify-content-center mb-5">
          <img width="130px" src={REACT} />
        </Col>

        <Col className="d-flex justify-content-center mb-5">
          <img width="120px" src={TS} />
        </Col>
        <Col className="d-flex justify-content-center mb-5">
          <img width="120px" src={WEB3} />
        </Col>
        <Col className="d-flex justify-content-center mb-5">
          <img width="120px" src={GITHUB} />
        </Col>
      </Row>
      <CText
        className="subText"
        fontSize="1.2rem"
        text={
          "As a frontend developer, I excel in leveraging modern technologies to create captivating user interfaces. With expertise in HTML, CSS/SCSS, JavaScript, and React, I craft seamless and interactive web experiences. My skills extend to integrating web3 technologies and blockchain interactions. Proficient in GitHub and experienced with libraries like Ant Design and Material-UI, I build visually stunning and responsive designs. Committed to staying updated with the latest trends, I deliver innovative solutions that merge functionality with aesthetics."
        }
      />
    </div>
  );
}

export default Skills;
